import classNames from 'classnames';
import { FC } from 'react';
import Colors from '~/constants/colors';
import Icon from '../Icon';
import Text from '../Text';
import styles from './Quantity.module.scss';
import MinusIcon from '~/assets/svgs/minus.svg';
import AddIcon from '~/assets/svgs/add.svg';

interface QuantityProps {
    value: number;
    onChange?: (value: number) => void;
    maxValue?: number;
}

const Quantity: FC<QuantityProps> = ({ value = 0, onChange, maxValue = 0 }) => {
    const handleDecrease = () => {
        if (value > 1) {
            onChange?.(value - 1);
        }
    };

    const handleIncrease = () => {
        if (!maxValue || value < maxValue) {
            onChange?.(value + 1);
        }
    };

    return (
        <div className={styles.quantity}>
            <MinusIcon
                className={classNames(styles.icon, {
                    [styles.disabled]: value === 1
                })}
                color={Colors.GREY_800}
                onClick={handleDecrease}
            />
            <Text>{value}</Text>
            <AddIcon
                className={classNames(styles.icon, {
                    [styles.disabled]: maxValue && value === maxValue
                })}
                color={Colors.GREY_800}
                onClick={handleIncrease}
            />
        </div>
    );
};

export default Quantity;
